var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"text-secondary",attrs:{"to":_vm.to}},[_c('small',[_c('b-icon-pencil'),_vm._v(" ändern")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }